import styled from 'styled-components';
import { StyledButton as Button } from '../../CommonComponents/Button';

export const Bar = styled.div`
  background: #fff;
  flex-shrink: 0;
  flex-grow: 1;

  border-bottom: ${({ theme }) =>
    theme.legacy.colors.brand && `4px solid ${theme.legacy.colors.brand}`};
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 30px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  @media (max-width: 1545px) {
    max-width: initial;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints[0]}) {
    padding: 0 16px;
  }
`;

export const NavigationLink = styled.li`
  display: inline-block;
  margin: 0;
  padding: 0;

  &:hover {
    .adv-dropdown {
      display: block;
    }
  }

  ${Button.PrependedIcon} {
    margin-right: 15px;
    display: none;
  }

  @media (max-width: 1200px) {
    ${Button.ChildrenWrapper} {
      display: none;
    }

    ${Button.PrependedIcon} {
      display: inline-block;
      margin: 0;
    }
  }
`;

export const NavigationLinkWithIcon = styled(NavigationLink)`
  ${Button.PrependedIcon} {
    display: inline-block;
  }
`;

export const RightSideNavigation = styled(NavigationLink)`
  margin-left: 20px;
  ${Button.PrependedIcon} {
    display: inline-block;
  }
`;

export const NavigationLinks = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  align-items: center;
`;

export const MainNavigationLinks = styled(NavigationLinks)``;

export const SecondaryNavigationLinks = styled(NavigationLinks)`
  margin-left: auto;
`;

export const ButtonWithBigIcon = styled(Button.Link)`
  padding: 26px 10px 25px 10px !important;

  ${Button.PrependedIcon} {
    font-size: 1.5em;
    margin: 0;
    vertical-align: middle;
  }
`;

export const DefaultLogo = styled.img`
  width: 48px !important;
  margin: 12px 0 12px -13px !important;
`;
